<script>
export default {
    name: 'OrderItem',
    props: {
        model: null,
        history: Boolean,
        cc: Boolean,
    },
    computed: {
        quantity() {
            return this.model?.quantity
        },
        price() {
            return this.model?.price * this.quantity
        },
        mealName() {
            return this.cc ? this.model?.mealName : this.model?.meal?.name
        },
        mealOptions() {
            return this.cc ? this.model?.mealOptions : this.model.children
        },
    },
}
</script>

<template lang="pug">
.order-item(v-if="model" :class="{'px-2': history}")
    v-row
        v-col.font-weight-bold(cols="1" align-self="baseline") {{ quantity }}x
        v-col(align-self="baseline")
            .font-weight-bold {{ mealName }}
        v-col.text-right(cols="2" align-self="baseline") {{ price | currency }}
    v-row(v-for="(child, index) in mealOptions" :key="`mealChild-${index}`")
        v-col.pt-0(align-self="baseline" offset="1")
            .order-details
                template(v-if="child.mealoptiongroup") {{ child.mealoptiongroup.name }}
                template(v-else-if="child.group") {{ child.group }}
                .font-weight-bold
                    template(v-if="child.quantity > 1 || quantity > 1") {{ child.quantity }}x&nbsp;
                    template(v-if="child.mealoption") {{ child.mealoption.name }}
                    template(v-else-if="child.name") {{ child.name }}
                    template(v-if="quantity > 1") &nbsp;{{ $t('orders.each', { quantity: quantity * child.quantity }) }}
        v-col.text-right.pt-0(cols="2" align-self="baseline") {{ child.price * child.quantity * quantity | currency }}

</template>

<style scoped lang="scss">
.order-item {
    border-top: 1px solid var(--v-g-e8-base);
    .order-details {
        border-left: 1px solid var(--v-g-e8-base);
        padding-left: 15px;
    }
}
</style>
